import './App.css';
import './utils/global.css';

import { Toaster } from './components/ui/toaster';
import AppRouter from './routes';

const App = () => {
  return (
    <div>
      <AppRouter />
      <Toaster />
    </div>
  );
};
export default App;
